'use strict';

module.exports = {
    ACTIONS: {
        TYPE: {
            CATEGORY: 'CATEGORY',
            ATTRIBUTE: 'ATTRIBUTE'
        },
        FIELDS: {
            IMAGES: 'IMAGES'
        }
    },
    STORE: {
        FETCH_SUCCESS: 'recommendations:fetch:success',
        FETCH_ERROR: 'recommendations:fetch:error'
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/constants/recommendationsConstants.es.js